import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// 暂时注释掉可能导致问题的store访问，等系统稳定后再逐步恢复
// import { ref, computed, onMounted, onUnmounted } from 'vue'
// import { useFriendStore } from './store/friend'
// import { useSocketStore } from './store/socket'
// import { useUserStore } from './store/user'

// const friendStore = useFriendStore()
// const socketStore = useSocketStore()
// const userStore = useUserStore()

// Lifecycle
// onMounted(async () => {
//   if (!userStore.userInfo.userId && !userStore.userInfo.id) {
//     await userStore.fetchUserInfo()
//   }
//   socketStore.connect()
//   friendStore.bindWsHandlers(socketStore) 

//   await Promise.all([
//     friendStore.loadFriends(),
//     friendStore.loadGroups(),
//     friendStore.loadPendingRequests(),
//   ])

//   const ids = (friendStore.friends || []).map(f => f.user_id).filter(Boolean)
//   if (ids.length) socketStore.requestFriendStatus(ids)
// })

// onUnmounted(() => {
//   socketStore.disconnect()
// })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})